
// import AssignTrackerDialog from './AssignTrackerDialog';
import React from 'react';
import { useActions, useValues } from 'kea';

import geofencelogic from 'src/store/geofence';

import EditDialog from './EditDialog';
import RemoveDialog from './RemoveDialog';



const ActionButtons = ({ row, index }) => {

	const { update } = useActions(geofencelogic);

	const handle_edit = (existing_geofence) => {
		update(existing_geofence);
	}

	const handle_remove = () => {
		row.vehicles.splice(index, 1);
		update(row);
	}

	return (
		<div style={{ display: 'flex', flexGrow: 1, justifyContent: 'flex-end' }}>
			<EditDialog geofence={row} index={index} OnEdit={handle_edit} />
			<RemoveDialog OnRemove={handle_remove} />
		</div>
	);
};

export default ActionButtons;
